import React from "react";
import { Chip, Box } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";

const OPENING_STATUSES = new Set(["OPENING", "qrcode", "PENDING"]);

const ConnectionStatusBadge = ({ status, classes }) => {
  if (status === "CONNECTED") {
    return (
      <Chip
        icon={<CheckCircle style={{ color: '#4caf50', fontSize: '16px' }} />}
        label="Conectada"
        className={`${classes.statusBadge} ${classes.connectedBadge}`}
        size="small"
      />
    );
  }

  if (OPENING_STATUSES.has(status)) {
    return (
      <Box display="flex" alignItems="center" style={{ marginTop: 8 }}>
        <Box
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#ff9800',
            marginRight: '6px',
          }}
        />
        <Chip
          label="Conectando..."
          className={classes.statusBadge}
          style={{ backgroundColor: '#fff3e0', color: '#e65100', borderColor: '#ff9800' }}
          size="small"
        />
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" style={{ marginTop: 8 }}>
      <Box
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: '#f44336',
          marginRight: '6px',
        }}
      />
      <Chip
        label="Desconectada"
        className={`${classes.statusBadge} ${classes.disconnectedBadge}`}
        size="small"
      />
    </Box>
  );
};

export default ConnectionStatusBadge;
